
define('jst!tooltips/_calendar_event',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% if (data.title) { %>\n  <%= title %>\n<% } %>\n<% if (data.ref) { %>\n  <%= data.ref %>\n<% } %>\n<% if (data.future_occurrence) { %>\n  <span class="tooltip_future_occurrence"><%= data.future_occurrence %></em>\n<% } %>\n');
 });

